import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const SectionTemplatePage_SectionTemplate_Foapu_Mutation = graphql(`
  mutation SectionTemplatePage_SectionTemplate_Foapu(
    $filter: IdFilterInput!
    $update: SectionTemplatePartialInput!
    $versionData: VersionDataInput
  ) {
    findOneAndPartialUpdateSectionTemplate(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type SectionTemplate_Foapu_Result = ResultOf<
  typeof SectionTemplatePage_SectionTemplate_Foapu_Mutation
>;

export const useFoapuSectionTemplateMutation = () =>
  useGraphQLMutation(SectionTemplatePage_SectionTemplate_Foapu_Mutation);
